// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"9137d77bbbab62be","5763":"585ef43a35cf31a3","6893":"35b5e59e2434568a","6974":"22aee3b2372e1fae","7222":"5ee01f29ac279c72","7937":"067a59335851e359"}[chunkId] + ".js";
};